export default [
  {
    id: 'profile',
    title: 'プロフィール',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '住所',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '連絡先',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'id-photo',
    title: '証明写真',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-historyBaikaGrad',
    title: '学歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'job-history',
    title: '職歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'prBaika_Grad',
    title: '自己PR',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'reasonBaika_Grad',
    title: '志望動機',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'etcBaika_Grad',
    title: '研究課題ほか',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'etc2Baika_Grad',
    title: '課外活動など',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'etc3Baika_Grad',
    title: '資格・免許',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'output',
    title: 'ダウンロード',
    previewJumpId: 'close-preview-button-above'
  }
]
